var map = {
	"./": "./src/assets/icons/index.tsx",
	"./activity.svg": "./src/assets/icons/activity.svg",
	"./arrow.svg": "./src/assets/icons/arrow.svg?b799",
	"./book.svg": "./src/assets/icons/book.svg?9297",
	"./chart.svg": "./src/assets/icons/chart.svg",
	"./check-circle.svg": "./src/assets/icons/check-circle.svg?09d1",
	"./downArrowImg.svg": "./src/assets/icons/downArrowImg.svg",
	"./errorImg.svg": "./src/assets/icons/errorImg.svg?a37c",
	"./graduate.svg": "./src/assets/icons/graduate.svg?1d83",
	"./home.svg": "./src/assets/icons/home.svg",
	"./index": "./src/assets/icons/index.tsx",
	"./index.tsx": "./src/assets/icons/index.tsx",
	"./logout.svg": "./src/assets/icons/logout.svg?3c45",
	"./mediaIcon.svg": "./src/assets/icons/mediaIcon.svg?3630",
	"./notificationImg.svg": "./src/assets/icons/notificationImg.svg",
	"./on.activity.svg": "./src/assets/icons/on.activity.svg",
	"./on.chart.svg": "./src/assets/icons/on.chart.svg",
	"./on.home.svg": "./src/assets/icons/on.home.svg",
	"./on.profile.svg": "./src/assets/icons/on.profile.svg",
	"./profile.svg": "./src/assets/icons/profile.svg",
	"./search.svg": "./src/assets/icons/search.svg?f85e",
	"./shoppingCart.svg": "./src/assets/icons/shoppingCart.svg",
	"./successIcon.svg": "./src/assets/icons/successIcon.svg?89de",
	"./upArrowImg.svg": "./src/assets/icons/upArrowImg.svg",
	"./uploadImg.svg": "./src/assets/icons/uploadImg.svg?6361",
	"./userImg.svg": "./src/assets/icons/userImg.svg?4cc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*$";